import React from 'react';
import { Icon } from '../ui';

/**
 * The sources a view could not read. The backend answers with whatever it could read
 * and names the rest in `warnings` (a missing permission, a throttled API, a sampler
 * that has not written yet), so the figures that are shown are current and the missing
 * ones are accounted for rather than drawn as zero.
 */
export default function SourceWarnings({ warnings }) {
  const list = [...new Set((warnings || []).filter(Boolean))];
  if (list.length === 0) return null;
  return (
    <div className="notice notice-warn" role="status">
      <Icon name="info" />
      <div className="notice-body">
        <div className="notice-title">
          {list.length === 1 ? 'One source could not be read' : `${list.length} sources could not be read`}
        </div>
        Everything else on this view is current. The figures that depend on these are left empty.
        <ul className="source-warnings">
          {list.map(w => <li key={w} className="text-sm">{w}</li>)}
        </ul>
      </div>
    </div>
  );
}
